import RegistrationSuccessPage from './RegistrationSuccessPage';
import { RegistrationSuccessPageProps, RegistrationSuccessPageValueProps } from './types';

export type { RegistrationSuccessPageProps, RegistrationSuccessPageValueProps };
export default RegistrationSuccessPage;
